import Model from '../models/model';

const model = new Model({
	name: 'IncubatorCycleDetail',
	defaultSort: 'BIInTime DESC',
	disableAdd: false,
	disableDelete: true,
	disableColumnSelector: true,
	disableExport :true,
	disablePreferences:true,
	disableFiltering: true,
	showGridRefreshBtn: true,
	columns: [
		{ header: 'TestControl', field: 'BIType', width: 150 },
		{ header: 'Load', field: 'LoadNumber', width: 120 },
		{ header: 'Sterilizer', field: 'Sterilizer', width: 150 },
		{ header: 'LotNumber', field: 'LotNumber', width: 100, },
		{ header: 'DateTime', field: 'BIInTime', width: 160, type: 'dateTime', },
		{ header: 'Incubator', field: 'Incubatorheader', width: 100 },
		{ header: 'NumberOfWell', field: 'Well',width: 150 },
		{ header: 'Result', field: 'BIResultIcon',width: 150, },
		{ header: 'Cycle', field: 'CycleCount', width: 150 }
	]
});
export const IncubatorCycleTable = model;
export default model.createFormBase();